import Dashboard from '@/views/dashboard/Dashboard.vue'
import Allocation from '@/views/dashboard/Allocation'
import Account from '@/views/dashboard/Account'

//in future release, Dashboard must be 1st vue
const routes = [
    {
        component: Dashboard,
        name: 'dashboard',
        path: '/:account_id/dashboard',
        redirect: '/:account_id/dashboard/account',
        children: [
            {
                path: 'allocation',
                name: 'allocation',
                component: Allocation
            },
            {
                path: 'account',
                name: 'account',
                component: Account
            }
        ]
    },
    {
        path: '/:account_id',
        redirect: '/:account_id/dashboard/account'
    }
]

export default routes
